import { FC, HTMLAttributes, useEffect, useState } from "react";
import cn from "classnames";
import { Col, Row } from "reactstrap";
import { Link, FeedbackMessage } from "@redoc/ui-kit";
import MaskInput from "src/Components/Controls/MaskInput/MaskInput";
import { GarInput, FieldGroup, Input } from "./Components";
import { GarAddressType } from "./Types";
import { GarDataModel, GarFieldDataModel } from "./GarDataModel";
import st from "./Gar.module.scss";

interface IGarFieldProps extends HTMLAttributes<HTMLDivElement> {

	//
	name: string;
	initTextValue?: string;

	value: GarAddressType | null;
	onChangeAddress?: ( address: GarAddressType | null ) => void;

	model: GarDataModel;
	onUpdateModel?: ( newModel: GarDataModel ) => void;

	placeholder?: string;
	disabled?: boolean;
	isInvalidate?: boolean;

	sendOnlyChange?: boolean;
};

/**  */
const GarField: FC<IGarFieldProps> = ( props ) => {

	const { 
		name, title, placeholder, isInvalidate, model, disabled, value, initTextValue,
		onChangeAddress, onUpdateModel, sendOnlyChange
	} = props;

	const [ isViewDetails, setIsViewDetails ] = useState<boolean>(false);
	const toggleViewDetails = () => setIsViewDetails( prev => !prev );

	const [ validateMessage, setValidateMessage ] = useState<string>("");

	useEffect( () => {
		model.onUpdateByAddress( value );
		if ( onUpdateModel ) {
			onUpdateModel( model );
		}
	}, [ value ] );

	/** Функция изменения значения ГАР-адреса */
	const onChangeAddressHandler = ( value: GarAddressType | null ) => {
		const updatedModel = { ...model.onUpdateByAddress( value ) };
		updatedModel.validationEnabled = true;
		if ( onUpdateModel ) {
			onUpdateModel( updatedModel );
		}
		let errorMessage = "";
		if ( !updatedModel.isValid() ) {
			errorMessage = "Поля заполнены не корректно.";
			setIsViewDetails(true);
		}
		setValidateMessage( errorMessage );
		if ( onChangeAddress ) {
			onChangeAddress( value );
		}
	};

	/** Функция изменения значения поля */
	const onChangeFieldValue = ( fieldModel: GarFieldDataModel, val: string ) => {
		fieldModel.text = val;
		model.validationEnabled = true;
		const newValue = model.getValue();
		if ( onUpdateModel ) {
			onUpdateModel( {...model} );
		}
		if ( onChangeAddress ) {
			onChangeAddress( newValue );
		}
	};

	/** Отрисовка инпута ввода ГАР-поля */
	const renderInput = ( model: GarFieldDataModel ) => {
		const inputProps = {
			id: name + "_" + model.fieldName,
			value: model.text ?? "",
			readOnly: disabled || model.readOnly,
			mask: model.mask,
			onChangeValue: model.readOnly ? undefined : ( val: string ) => onChangeFieldValue( model, val )
		};
		if ( !!model.mask )
			return <MaskInput {...inputProps} />;
		else
			return <Input {...inputProps} />;
	};

	/** Отрисовка поля ГАР по модели */
	const renderField = ( model: GarFieldDataModel ) => {
		if ( !model.visible ) return null;
		return (
			<Col key={ "GarOf" + name + "_"  + model.code} md={model.width}>
				<FieldGroup
					isRequired={model.required}
					name={ name + "_" + model.fieldName}
					isInvalid={model.notValid}
					errorMsg={model.notValidError}
					title={model.caption}
					width={model.width}
				>
					{ renderInput( model ) }
				</FieldGroup>
			</Col>
		);
	};

	/** Отрисовка набора полей подробного адреса */
	const renderDetails = () => (
		<fieldset>
			<Row xs="12">
				{ model.getFields().map( renderField ) }
			</Row>
		</fieldset>
	);

	return (
		<div className={st.gar}>
			<div className={st.gar__header}>
				<GarInput 
					name={name} 
					title={title} 
					isInvalidate={ isInvalidate || !model.isValid() } 
					placeholder={placeholder} 
					disabled={disabled}
					initTextValue={initTextValue}
					value={value ?? undefined}
					sendOnlyChange={sendOnlyChange}
					onChangeAddress={onChangeAddressHandler}
				/>
				<div className={st.gar__header__toolbar}>
					<Link className={cn(st.gar__header__link, { [st.open] : isViewDetails } )} onClick={toggleViewDetails}>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.13125 6.75L9 9.61875L11.8688 6.75L12.75 7.6375L9 11.3875L5.25 7.6375L6.13125 6.75Z" fill="#2196F3"/>
						</svg>
						<span>Уточнить адрес</span>
					</Link>
					<FeedbackMessage message={validateMessage} />
				</div>
			</div>
		 	{ isViewDetails && renderDetails() }
		</div>
	);
};

export default GarField;
